var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input-label',{attrs:{"label":_vm.item.name}},[_c('select-field',{attrs:{"name":_vm.item.name,"placeholder":_vm.item.name,"options":_vm.item.options},model:{value:(_vm.entity[_vm.accessor]),callback:function ($$v) {_vm.$set(_vm.entity, _vm.accessor, $$v)},expression:"entity[accessor]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }